module.exports = __webpack_public_path__ + "static/og_image-ca20c1f29c532ef0f6622791de5fcd90.png";